module.exports = __webpack_public_path__ + "static/media/iconSondageF.84d56ca7.svg";